
import React, { useState } from 'react';
import { LOCAL_TRIVIA } from '../services/localData';

const Trivia: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);
  const [selected, setSelected] = useState<number | null>(null);

  const reset = () => {
    setFinished(false);
    setCurrentIndex(0);
    setScore(0);
    setSelected(null);
  };

  const handleAnswer = (index: number) => {
    if (selected !== null) return;
    setSelected(index);
    if (index === LOCAL_TRIVIA[currentIndex].answer) {
      setScore(s => s + 1);
    }
    setTimeout(() => {
      if (currentIndex < LOCAL_TRIVIA.length - 1) {
        setCurrentIndex(c => c + 1);
        setSelected(null);
      } else {
        setFinished(true);
      }
    }, 1000);
  };

  if (finished) return (
    <div className="text-center p-8 bg-slate-800 rounded-2xl border border-slate-700 shadow-xl game-transition">
      <h2 className="text-3xl font-bold mb-4">Quiz Complete!</h2>
      <p className="text-6xl font-black text-blue-500 mb-6">{score} / {LOCAL_TRIVIA.length}</p>
      <button onClick={reset} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full transition-all">New Quiz</button>
    </div>
  );

  const q = LOCAL_TRIVIA[currentIndex];

  return (
    <div className="max-w-2xl w-full game-transition">
      <div className="mb-8">
        <div className="flex justify-between items-center mb-4">
          <span className="text-slate-400 font-mono">Question {currentIndex + 1} of {LOCAL_TRIVIA.length}</span>
          <span className="text-blue-400 font-bold">Score: {score}</span>
        </div>
        <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
          <div className="h-full bg-blue-500 transition-all duration-500" style={{ width: `${((currentIndex + 1) / LOCAL_TRIVIA.length) * 100}%` }} />
        </div>
      </div>
      <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700 shadow-xl">
        <h3 className="text-2xl font-bold mb-8 text-white">{q.question}</h3>
        <div className="grid grid-cols-1 gap-4">
          {q.options.map((opt, i) => {
            const isCorrect = i === q.answer;
            const isSelected = i === selected;
            let bgColor = "bg-slate-700 hover:bg-slate-600 border-slate-600 hover:border-blue-500/50";
            if (selected !== null) {
              if (isCorrect) bgColor = "bg-green-600 border-green-400";
              else if (isSelected) bgColor = "bg-red-600 border-red-400";
              else bgColor = "bg-slate-700 opacity-50 border-slate-700";
            }
            return (
              <button key={i} disabled={selected !== null} onClick={() => handleAnswer(i)} className={`p-4 text-left rounded-xl border-2 transition-all font-semibold ${bgColor}`}>
                {opt}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Trivia;
